import styled from "styled-components";


export const TabContainer = styled.div`
  height: ${({ theme }) => theme.tabsToken.cardHeight};
  width:100%;
  max-width: 100%;
  .ant-tabs-card > .ant-tabs-nav .ant-tabs-nav-list{
      flex:1;
  }
  
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab{
        border-radius: 0 !important;
        border:none;
        font-size: 14px;
        font-weight: 500;
        flex: 1 1 auto;
        justify-content: center;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active){
        color:rgba(21, 33, 41, 0.6);
        box-shadow: -1px 0 9px rgba(0, 0, 0, 0.13), 1px 0 9px rgba(0, 0, 0, 0.13);
        background: #eef0f2;
    }

    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active::after{
    height: 4px;
    width: 50%;
    content: "";
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: var(--border-radius);
    background-color: var(--accent);
    }
  

  .ant-tabs-nav::before{
    display:none;
  }

  .ant-tabs-content-holder{
  padding: ${({ theme }) => theme.tabsToken.cardPadding};
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-nav-wrap{
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.27);
  border-bottom:1px solid rgba(0,0,0,0.15);
  }

  .ant-tabs-left,
  .ant-tabs-right{
    .ant-tabs-tab{
      flex: none;
    }
    .ant-tabs-extra-content{
     order:0;
     padding-top:10px;
    }
    .ant-tabs-nav-wrap{
     order:2;
    }
  }
`;

export const StyledTabActions = styled.div`
  background-color: ${({ theme }) => theme.tabsToken.cardBg};
  padding: ${({ theme }) => theme.tabsToken.cardPadding};
  height: ${({ theme }) => theme.tabsToken.cardHeight || "inherit"};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;